import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

interface TransportCancellationPolicyProps {
  cancellationPolicy?: string | null;
}

export default function TransportCancellationPolicy({ cancellationPolicy }: TransportCancellationPolicyProps) {
  const { t } = useTranslation();

  return (
    <Box className={`transport-cancellation-policy`}>
      <Box className="transport-cancellation-policy__heading">{t("offerDetails.cancellationHeading")}:</Box>
      <Box className="transport-cancellation-policy__text">{cancellationPolicy}</Box>
    </Box>
  );
}
